/**
 * マニフェスト管理
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/rest_manifests`

const rest_manifest = {
  namespaced: true,
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}

export default rest_manifest
